<div class="autocomplete-box">
  <mat-form-field appearance="outline">
    <mat-label>{{label}}</mat-label>
    <input type="text" matInput [formControl]="itemCtrl" [matAutocomplete]="auto" [placeholder]="placeholder">
    <button *ngIf="clearButton && itemCtrl.value" matSuffix mat-icon-button (click)="clear()">
      <mat-icon>close</mat-icon>
    </button>
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onSelectionChange($event)">
      <mat-option *ngFor="let item of filteredItems$ | async" [value]="item" [style.color]="item.color">
        {{item.label}}
      </mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="itemCtrl.invalid">{{requiredErrorMessage}}</mat-error>
    <mat-error *ngIf="itemCtrl.errors?.['exists']">La valeur doit etre un de la liste</mat-error>

  </mat-form-field>

</div>
